import React from 'react'
import styled from 'styled-components'

const swatchSize = 12
const swatchSpace = 1
export const Key = ({
  entries,
}: {
  entries: {
    type: 'line' | 'shape' | 'none' | 'shape-pattern' | 'shape-multi'
    label: string
    color: string | string[]
  }[]
}) => {
  return (
    <StyledKey className='Key'>
      {entries.map((m, i) => {
        return (
          <div className='entry' key={'Key_' + i}>
            <div className='swatch'>
              {m.type === 'shape' ? (
                <SwatchShape color={m.color as string} />
              ) : m.type === 'shape-pattern' ? (
                <SwatchShapePattern color={m.color as string} />
              ) : m.type === 'line' ? (
                <SwatchLine color={m.color as string} />
              ) : m.type === 'shape-multi' ? (
                <SwatchShapeMulti color={m.color as string} />
              ) : (
                <SwatchNone />
              )}
            </div>
            <div className='label'>{m.label}</div>
          </div>
        )
      })}
    </StyledKey>
  )
}

const StyledKey = styled.div`
  display: flex;
  font-size: 13px;
  font-weight: 400;
  margin-top: 15px;
  margin-bottom: 60px;
  flex-wrap: wrap;

  .entry {
    flex: 0 0 auto;
    margin-bottom: 8px;
    display: flex;
    padding-right: 1em;
    line-height: 1em;
    @media only screen and (max-width: 711px) {
      flex: 0 0 100%;
    }

    .label {
      width: 100%;
      @media only screen and (max-width: 600px) {
        flex: 0 0 100%;
      }
    }
    .swatch {
      padding-right: 0.5em;
    }
  }
`

const SwatchShapeMulti = ({ color }: { color: string | string[] }) => {
  return (
    <svg width={swatchSize * 2 + swatchSpace} height={swatchSize}>
      <rect width={swatchSize} height={swatchSize} fill={color[0]} />
      <rect
        x={swatchSize + swatchSpace}
        width={swatchSize}
        height={swatchSize}
        fill={color[1]}
      />
    </svg>
  )
}
const SwatchShape = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <rect width={swatchSize} height={swatchSize} fill={color} />
    </svg>
  )
}
const SwatchShapePattern = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <pattern
        id='diagonalHatch'
        patternUnits='userSpaceOnUse'
        width='4'
        height='4'
        style={{ transform: 'scale(1.5)' }}
      >
        <path
          d='M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2'
          style={{ stroke: color, strokeWidth: 1 }}
        />
      </pattern>
      <rect width={swatchSize} height={swatchSize} fill='url(#diagonalHatch)' />
    </svg>
  )
}
const SwatchLine = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <line
        x2={swatchSize}
        y1={swatchSize}
        y2={0}
        stroke={color}
        strokeWidth={4}
      />
    </svg>
  )
}
const SwatchNone = () => {
  return <svg width={swatchSize} height={swatchSize}></svg>
}
